module.exports = __webpack_public_path__ + "img/Godbole.c6cb9ac1.png";